/*
 * @Author: LZT
 * @Date: 2024-12-11 16:15:19
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\router\modules\user.js
 */
import Layout from "@/Layout";
export default [
  {
    path: "/vip",
    component: Layout,
    redirect: "/vip/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/gnPage/vip/index.vue"),
        name: "StrategyVip",
        meta: {
          title: "我的",
          keepAlive: true,
          showFooter: true,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
    ]
  },
  {
    path: "/product",
    component: Layout,
    name: "product",
    redirect: "/product/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/product/index.vue"),
        meta: {
          title: "我的产品",
          keepAlive: false,
          showHead: true,
          showLeft: true,
          navStyle: "fff"
        }
      }
    ]
  },
  {
    path: "/agreement",
    component: Layout,
    name: "agreement",
    redirect: "/agreement/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/agreement/index.vue"),
        meta: {
          title: "用户协议",
          keepAlive: false,
          showHead: true,
          showLeft: true,
          navStyle: "fff"
        }
      },
      {
        path: "indexApp",
        component: () => import("@/views/agreement/index.vue"),
        meta: {
          title: "用户协议",
          keepAlive: false,
          showHead: false,
          showLeft: false,
          navStyle: "fff"
        }
      },
      {
        path: "indexFlutterApp",
        component: () => import("@/views/agreement/flutterApp/indexFlutter.vue"),
        meta: {
          title: "用户协议",
          keepAlive: false,
          showHead: false,
          showLeft: false,
          navStyle: "fff"
        }
      },
      {
        path: "policy",
        component: () => import("@/views/agreement/policy.vue"),
        meta: {
          title: "隐私政策",
          keepAlive: false,
          showHead: true,
          showLeft: true,
          navStyle: "fff"
        }
      },
      {
        path: "policyApp",
        component: () => import("@/views/agreement/policy.vue"),
        meta: {
          title: "隐私政策",
          keepAlive: false,
          showHead: false,
          showLeft: false,
          navStyle: "fff"
        }
      },
      {
        path: "policyFlutterApp",
        component: () => import("@/views/agreement/flutterApp/policyFlutter.vue"),
        meta: {
          title: "隐私政策",
          keepAlive: false,
          showHead: false,
          showLeft: false,
          navStyle: "fff"
        }
      },
      {
        path: "infoInventory",
        component: () => import("@/views/agreement/infoInventory.vue"),
        meta: {
          title: "个人信息收集清单",
          keepAlive: false,
          showHead: true,
          showLeft: true,
          navStyle: "fff"
        }
      },
      {
        path: "thirdPartyInventory",
        component: () => import("@/views/agreement/thirdPartyInventory.vue"),
        meta: {
          title: "第三方信息收集清单",
          keepAlive: false,
          showHead: true,
          showLeft: true,
          navStyle: "fff"
        }
      }
    ]
  }
];
